export { default } from './convertToSeconds'
